import React from 'react';
import './MainContainer.css';
import { ProfileContainer } from '../profile-container/ProfileContainer';
import { ContentContainer } from '../content-container/ContentContainer';

export const MainContainer = () => {
    return (
        <div className="main-container">
            <ProfileContainer />
            <ContentContainer />            
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/main-container/MainContainer.jsx